<div style="margin-top: 30px; margin-bottom: 30px;" class="container">
  <div class="card">
    <div class="card-body">
      <h5 class="card-title zaya-form-header" i18n="button|Where a user practitioner can register their account.@@buttonCreateAccount">
        Create Account
      </h5>
      <div class="d-flex flex-fill justify-content-center mb-4 zaya-form-help-text text-center" i18n="label|Help text for registering a practitioner account.@@labelRegisterHelpText">
        You are officially part of a growing community where hundreds of people are joining us every month to learn more about integrative and mind-body approaches to supporting their
        mental health and physical wellbeing. What a beautiful feeling! Check out your new profile by creating a password below!
      </div>
      <app-loader *ngIf="isLoading"></app-loader>
      <form [formGroup]="authenticateForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="email" i18n="label|The email of a user.@@labelEmail" class="zaya-form-sub-header">Email</label>
          <input type="email" id="email" class="form-control" formControlName="email">
          <span
            class="help-block"
            *ngIf="authenticateForm.get('email').invalid && authenticateForm.get('email').touched"
            i18n="error message|The message shown when an email has not been entered.@@errorEmail">
              Please enter a valid email.
          </span>
        </div>

        <div class="row">
          <div class="form-group col-xs-12 col-md-6">
            <label for="password" i18n="label|The password of a user.@@labelPassword" class="zaya-form-sub-header">Password</label>
            <input type="password" id="password" class="form-control" formControlName="password">
            <span
              class="help-block"
              *ngIf="authenticateForm.get('password').invalid && authenticateForm.get('password').touched"
              i18n="error message|The message shown when a password is not valid.@@errorPassword">
                Please enter a valid password.
            </span>
          </div>

          <div class="form-group col-xs-12 col-md-6">
            <label for="confirmPassword" i18n="label|The password confirmation of a user.@@labelConfirmPassword" class="zaya-form-sub-header">Confirm password</label>
            <input type="password" id="confirmPassword" class="form-control" formControlName="confirmPassword">
            <span
              class="help-block"
              *ngIf="authenticateForm.get('confirmPassword').invalid && authenticateForm.get('confirmPassword').touched"
              i18n="error message|The message shown when a password is not valid.@@errorConfirmPassword">
                The passwords you entered do not match.
            </span>
          </div>
        </div>

        <div *ngIf="error" class="alert alert-danger">
          <span>{{error}}</span>
        </div>

        <div class="d-flex flex-fill justify-content-center mt-3">
          <button class="btn btn-primary login-btn" type="submit" i18n="button|Where a user practitioner can register their account.@@buttonCreateAccount" [disabled]="isLoading">Create Account</button>
        </div>
      </form>
    </div>
  </div>
</div>
